import { useParams, useSearchParams } from 'next/navigation';
import { SEARCH_PARAM } from '@/constants/searchParams';

export function useSaleIdParam() {
  const params = useParams<{ saleId?: string }>();
  const searchParams = useSearchParams();
  if (params?.saleId != null && params.saleId !== '') {
    return params.saleId;
  }
  return searchParams?.get(SEARCH_PARAM.SALE_ID);
}
